import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, isPricingPowerAdvisorPage, trackEvent, trackPageView } from "@/lib/analytics";

export const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const lastRouteRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isPricingPowerAdvisorPage(location.pathname)) void initAnalytics();
  }, [location.pathname]);

  useEffect(() => {
    const route = `${location.pathname}${location.search}`;
    if (lastRouteRef.current === route) return;
    lastRouteRef.current = route;

    const timeoutId = window.setTimeout(() => {
      trackPageView(route, document.title);
      if (location.pathname === "/") {
        trackEvent("homepage_viewed", { page_path: "/" });
      }
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [location.pathname, location.search]);

  return null;
};
